import { useEffect, useRef } from 'react';
import { Icon } from '../../components/Icon.tsx';
import type { IconName } from '../../components/Icon.tsx';

/**
 * ⋯ 옵션 메뉴 — F3-1 · F4-4.
 *
 * ⋯ 바로 아래에 붙어 펼쳐집니다. **목록을 덮지 않습니다** — 무엇에 대한
 * 메뉴인지 배경이 계속 보여야 하고, 시트로 올리면 화면 절반이 가려집니다.
 *
 * 취소는 선 아래 회색, 되돌리기 어려운 것은 빨강입니다. 메뉴 바깥 · 취소 ·
 * Esc 어느 쪽을 눌러도 메뉴만 닫힙니다.
 *
 * 권한에 따라 항목이 다릅니다 — 그룹장은 수정 · 나가기, 그룹원은 나가기만
 * (F3-1). 무엇을 넘길지는 부르는 쪽이 정하고, 여기서는 받은 것만 그립니다.
 */

export interface Option {
  icon: IconName;
  label: string;
  /** 되돌리기 어려운 동작 — 빨간 글씨 */
  crit?: boolean;
  onClick: () => void;
}

interface Props {
  options: Option[];
  onClose: () => void;
}

export function OptionMenu({ options, onClose }: Props) {
  const saved = useRef(onClose);
  saved.current = onClose;

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') saved.current();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <>
      {/*
        투명한 스크림입니다. 어둡게 덮지 않는 것은 목록이 그대로 보여야
        하기 때문이고, 그래도 깔아 두는 것은 바깥을 눌러 닫을 자리가
        필요하기 때문입니다.
      */}
      <button
        type="button"
        className="scrim scrim--clear"
        aria-label="닫기"
        onClick={onClose}
      />
      <div className="ddmenu" role="menu">
        {options.map((o) => (
          <button
            key={o.label}
            type="button"
            role="menuitem"
            className={o.crit ? 'ddmenu__item ddmenu__item--crit' : 'ddmenu__item'}
            onClick={() => {
              onClose();
              o.onClick();
            }}
          >
            <Icon name={o.icon} size={16} />
            {o.label}
          </button>
        ))}

        <div className="ddmenu__sep" />
        <button
          type="button"
          role="menuitem"
          className="ddmenu__item ddmenu__item--mute"
          onClick={onClose}
        >
          <Icon name="close" size={16} />
          취소
        </button>
      </div>
    </>
  );
}
